import { LIBRARY_FILTER } from '../constants'
import { threeDStudioStore } from '../index'

export const GENERATED_FILTERS = [
  LIBRARY_FILTER.GENERATED_ALL,
  LIBRARY_FILTER.GENERATED_FAVORITES,
  LIBRARY_FILTER.GENERATED_DRAFTS,
]

/**
 * Adds a value to the library filter.
 * @param {string} filter - library filter to add
 */
export const addLibraryFilter = (filter) => {
  const state = threeDStudioStore.getState()
  const libraryFilter = state.libraryFilter || []

  if (filter === 'generated') {
    const currentFilters = libraryFilter.filter(item => !GENERATED_FILTERS.includes(item))
    threeDStudioStore.setState({ libraryFilter: [...currentFilters, LIBRARY_FILTER.GENERATED_ALL] })

    return
  }

  const currentFilters = GENERATED_FILTERS.includes(filter)
    ? libraryFilter.filter(item => !GENERATED_FILTERS.includes(item))
    : libraryFilter

  if (!currentFilters.includes(filter)) {
    threeDStudioStore.setState({ libraryFilter: [...currentFilters, filter] })
  }
}

/**
 * Removes a value from the library filter.
 * @param {string} filter - library filter to remove
 */
export const removeLibraryFilter = (filter) => {
  const state = threeDStudioStore.getState()
  const currentFilter = state.libraryFilter || []

  if (filter === 'generated') {
    const nextFilters = currentFilter.filter(item => !GENERATED_FILTERS.includes(item))
    threeDStudioStore.setState({ libraryFilter: nextFilters })

    return
  }

  threeDStudioStore.setState({ libraryFilter: currentFilter.filter((f) => f !== filter) })
}
